// import { CommonModule } from '@angular/common';
// import { Component } from '@angular/core';
// import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { Router, ActivatedRoute, RouterLink } from '@angular/router';
// import { AuthService } from 'src/app/services/auth.service';
// import { environment } from 'src/environments/environments';
// import { TooltipModule } from 'ngx-bootstrap/tooltip';
// declare var $: any;
// import Swal from 'sweetalert2'
// import { AngularFireDatabase } from '@angular/fire/compat/database';
// import { debounceTime } from 'rxjs';
// @Component({
//   selector: 'app-site-headers',
//   standalone: true,
//   imports: [CommonModule,
//     FormsModule,
//     ReactiveFormsModule,
//     TooltipModule,
//     RouterLink],
//   templateUrl: './site-headers.component.html',
//   styleUrl: './site-headers.component.scss'
// })
// export class SiteHeadersComponent {
//   role: any;
//   userType: any;
//   role_id: any | null;
//   facilities: any;
//   role_type: any | null;
//   user_name: any | null;
//   facility_id: any | null;
//   facility_name: any | null;

//   wasDeliveryActive = false;
//   adminName = localStorage.getItem(`${environment.appName}` + '_adminName');

//   //companyName = localStorage.getItem(`${environment.appName}` + 'companyName');
//   create_orders: any;
//   invoice_repor: any;
//   manage_access: any;
//   manage_client: any;
//   manage_orders: any;
//   userid: any;
//   pro_summary: any;
//   manage_products: any;
//   manage_users: any;
//   abstract_report: any;

//   home_page: any;
//   task_manager: any;
//   routeParam: any;
//   profileid: any;
//   userac: any;
//   useredit: any;
//   templeedit: any;
//   templeadd: any;
//   shlokaedit: any;
//   shubasitaedit: any;
//   visheshamedit: any;
//   quizedit: any;
//   approvaluser: any;
//   date: any;
//   dailydigestpreview: any;
//   dailydigestshloka: any;
//   dailydigestshubasita: any;
//   dailydigestvishesham: any;
//   dailydigestquiz: any;
//   dailydigestuser: any;
//   dailydigesttemple: any;
//   previewquiz: any;
//   count: any;
//   dailydigestshlokapublish: any;
//   dailydigestshubasitapublish: any;
//   dailydigestvisheshampublish: any;
//   dailydigestquizpublish: any;
//   dailydigesttemplepublish: any;
//   dailydigestuserpublish: any;
//   dailydigestschedule: any;
//   month: any;
//   year: any;
//   currentvishesham: any;
//   createtvishesham: any;
//   editcustomnotification: any;
//   editpanchangam: any;
//   permissions: string[] = [];
//   isGlobalAdmin: any;
//   showNotifyDropdown = false;
//   showVendorsDropdown = false;
//   showMarketingDropdown = false;
//   admin_id: any;

//   constructor(public router: Router,
//     private auth: AuthService,
//     private route: ActivatedRoute,
//     private db: AngularFireDatabase,) { }
//   ngOnInit() {
//     this.loadUserAccess();

//     this.role_id = localStorage.getItem(`${environment.appName}` + 'role_id');
//     if (this.role_id == 2) {
//       // this.residentsService.getstafffacilities()
//       //   .subscribe(data => {
//       //     this.facilities = data.data;
//       //   })

//     }
//     this.firebase();
//     this.user_name = localStorage.getItem(`${environment.appName}` + 'user_name');
//     this.role_type = localStorage.getItem(`${environment.appName}` + 'role_type');
//     this.facility_id = localStorage.getItem(`${environment.appName}` + 'facility_id');
//     this.facility_name = localStorage.getItem(`${environment.appName}` + 'facility_name');
//     $('#facility').val(this.facility_id)
//   }

//   loadUserAccess() {
//     const perms = localStorage.getItem('user_permissions');
//     this.permissions = perms ? JSON.parse(perms) : [];
//     this.userType = localStorage.getItem('userType') || '';
//     this.isGlobalAdmin = this.permissions.includes('globelPermission');
//   }


//   hasPermission(key: string): boolean {
//     return this.isGlobalAdmin || this.permissions.includes(key);
//   }


//   change(facility: any) {
//     localStorage.setItem(`${environment.appName}` + 'facility_id', facility._id);
//     localStorage.setItem(`${environment.appName}` + 'facility_name', facility.fecility_name);
//     location.reload();
//   }

//   menu() {
//     $(".user_option").toggle();
//     // e.preventDefault();
//   }

//   ApartmentUrl() {
//     if (this.router.url.includes("/apartment")) {
//       return true
//     } else if (this.router.url.includes("/add-apartment")) {
//       return true
//     } else if (this.router.url.includes("/apartment-details")) {
//       return true
//     } else {
//       return false
//     }
//   }

//   LaundryUrl() {
//     if (this.router.url.includes("laundry")) {
//       return true
//     } else if (this.router.url.includes("/laundry/category/add-category")) {
//       return true
//     } else if (this.router.url.includes("/laundry/subCategory")) {
//       return true
//     } else if (this.router.url.includes("/laundry/subCategory/add-subcategory")) {
//       return true
//     } else {
//       return false
//     }
//   }

//   RestuarantUrl() {
//     if (this.router.url.includes("/restaurant")) {
//       return true
//     } else if (this.router.url.includes("/add-restaurant")) {
//       return true
//     } else if (this.router.url.includes("/restaurant-details")) {
//       return true
//     } else {
//       return false
//     }
//   }

//   clubUrl() {
//     if (this.router.url.includes("/club")) {
//       return true
//     }
//     else if (this.router.url.includes("/add-club")) {
//       return true
//     }
//     else if (this.router.url.includes("/club-details")) {
//       return true
//     } else {
//       return false
//     }
//   }

//   spaUrl(){
//     if (this.router.url.includes("/spa")) {
//       return true
//     }
//      else if (this.router.url.includes("/add-spa")) {
//       return true
//     }
//     else if (this.router.url.includes("/spa-details")) {
//       return true
//     } else {
//       return false
//     }
//   }

//   settingUrl() {
//     if (this.router.url.includes("/setting")) {
//       return true
//     } else if (this.router.url.includes("/add-setting")) {
//       return true
//     } else {
//       return false
//     }
//   }
//   taxUrl() {
//     if (this.router.url.includes("/tax")) {
//       return true
//     } else if (this.router.url.includes("/add-tax")) {
//       return true
//     } else {
//       return false
//     }
//   }
//   UploadBannerUrl() {
//     if (this.router.url.includes("/upload-banner")) {
//       return true
//     } else if (this.router.url.includes("/sub-imgage1")) {
//       return true
//     }
//     else if (this.router.url.includes("/sub-imgage2")) {
//       return true
//     } else {
//       return false
//     }
//   }

//   staffUrl() {
//     if (this.router.url.includes("/staff")) {
//       return true
//     } else if (this.router.url.includes("/add-staff")) {
//       return true
//     } else {
//       return false
//     }
//   }
//   ReportUrl() {
//     if (this.router.url.includes("/laundry-report")) {
//       return true
//     } else if (this.router.url.includes("/room-service-report")) {
//       return true
//     } else if (this.router.url.includes("/restaurant-report")) {
//       return true
//     } else {
//       return false
//     }
//   }
//   FAQUrl() {
//     if (this.router.url.includes("/feedback")) {
//       return true
//     } else if (this.router.url.includes("/feedback/add-feedback")) {
//       return true
//     } else if (this.router.url.includes("/FAQ-category")) {
//       return true
//     } else if (this.router.url.includes("/FAQ-category/add-category")) {
//       return true
//     } else {
//       return false
//     }
//   }
//   OrderUrl() {
//     if (this.router.url.includes("/all-orders")) {
//       return true
//     } else if (this.router.url.includes("/order-detail")) {
//       return true
//     } else if (this.router.url.includes("/room-order-details")) {
//       return true
//     } else if (this.router.url.includes("/food-order-details")) {
//       return true
//     } else if (this.router.url.includes("/additional-order-details")) {
//       return true
//     } else {
//       return false
//     }
//   }
//   emgNotification(){
//       if (this.router.url.includes("/emergency-notification")) {
//       return true
//     } else if (this.router.url.includes("/saved-alert")) {
//       return true
//     } else if (this.router.url.includes("/active-alert")) {
//       return true
//     } else if (this.router.url.includes("/alert-response")) {
//       return true
//     } else if (this.router.url.includes("/alert-report")) {
//       return true
//       } else if (this.router.url.includes("/alert-history")) {
//       return true
//     } else {
//       return false
//     }
//   }

//   VendorsUrl() {
//     return this.LaundryUrl() || this.RestuarantUrl() || this.clubUrl() || this.spaUrl();
//   }

//   MarketingUrl() {
//     return this.UploadBannerUrl() || 
//            this.router.url.includes("/notification") || 
//            this.router.url.includes("/admin-notification") ||
//            this.emgNotification() || 
//            this.FAQUrl();
//   }

//   logout() {
//     var that = this;
//     Swal.fire({
//       title: 'Are You Sure You Want To Logout?',
//       icon: 'warning',
//       showCancelButton: true,
//       confirmButtonColor: '#3085d6',
//       cancelButtonColor: '#d33',
//       confirmButtonText: 'OK'
//     }).then((result) => {

//       if (result.isConfirmed) {
//         that.auth.logout();
//         that.router.navigate(['/login']);
//         //Swal.fire('Saved!', '', 'success')
//       } else if (result.isDenied) {
//         Swal.fire('Changes are not saved', '', 'info')
//       }
//     })
//   }


//   // fire base



//   previousOrderIds: string[] = [];

//   firebase() {
//     this.db.list("data").valueChanges().pipe(
//       debounceTime(300)
//     ).subscribe((data: any[]) => {

//       // Consider all order statuses
//       const allOrders = data.filter((item: any) =>
//         ["ordered", "accepted", "picked_up", "delivered", "cancelled", "rejected"].includes(item.orderStatus)
//       );

//       // Extract their IDs
//       const currentOrderIds = allOrders.map((o: any) => o.deliveryId);

//       // Get previously seen orders from localStorage
//       const previousOrderIds = JSON.parse(localStorage.getItem('previousOrderIds') || '[]');

//       // Check for new orders
//       const newOrders = currentOrderIds.filter(id => !previousOrderIds.includes(id));

//       if (newOrders.length > 0) {
//         // this.playCustomSound();

//         setTimeout(() => {
//           window.location.reload();
//         }, 1000);
//       }

//       // Save current order IDs to localStorage
//       localStorage.setItem('previousOrderIds', JSON.stringify(currentOrderIds));
//     });
//   }



//   playCustomSound() {


//     const AudioContext = window.AudioContext || (window as any).webkitAudioContext;
//     const audioContext = new AudioContext();

//     // Ensure context is resumed
//     if (audioContext.state === 'suspended') {
//       audioContext.resume().then(() => {
//         console.log("🎵 Audio context resumed");
//       });
//     }

//     const soundUrl = "/assets/images/swiggy_new_order.mp3"; // Use absolute path for reliability

//     fetch(soundUrl)
//       .then(res => res.arrayBuffer())
//       .then(buffer => audioContext.decodeAudioData(buffer))
//       .then(decoded => {
//         const source = audioContext.createBufferSource();
//         source.buffer = decoded;
//         source.connect(audioContext.destination);
//         source.start();

//       })
//       .catch(err => console.error("🔇 Sound error:", err));
//   }

//   clearDatabase() {
//     this.db.database
//       .ref()
//       .remove()
//       .then(() => {
//         console.log("Database cleared successfully.");
//       })
//       .catch((error) => {
//         console.error("Error clearing database:", error);
//       });
//   }

//   openVendorsDropdown() {
//     this.showVendorsDropdown = true;
//   }

//   closeVendorsDropdown() {
//     this.showVendorsDropdown = false;
//   }

//   openMarketingDropdown() {
//     this.showMarketingDropdown = true;
//   }

//   closeMarketingDropdown() {
//     this.showMarketingDropdown = false;
//   }

//   openNotifyDropdown() {
//     this.showNotifyDropdown = true;
//   }

//   closeNotifyDropdown() {
//     this.showNotifyDropdown = false;
//   }

// }
import { CommonModule } from '@angular/common';
import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute, RouterLink } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environments';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
declare var $: any;
import Swal from 'sweetalert2'
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { OrderRefreshService } from 'src/app/services/order-refresh.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-site-headers',
  standalone: true,
  imports: [CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TooltipModule,
    RouterLink],
  templateUrl: './site-headers.component.html',
  styleUrl: './site-headers.component.scss'
})
export class SiteHeadersComponent implements OnInit, OnDestroy {
  role: any;
  userType: any;
  role_id: any | null;
  facilities: any;
  role_type: any | null;
  user_name: any | null;
  facility_id: any | null;
  facility_name: any | null;

  wasDeliveryActive = false;
  adminName = localStorage.getItem(`${environment.appName}` + '_adminName');
  displayName = localStorage.getItem('display_name') || 'Admin';

  create_orders: any;
  invoice_repor: any;
  manage_access: any;
  manage_client: any;
  manage_orders: any;
  userid: any;
  pro_summary: any;
  manage_products: any;
  manage_users: any;
  abstract_report: any;
  home_page: any;
  task_manager: any;
  routeParam: any;
  profileid: any;
  userac: any;
  useredit: any;
  templeedit: any;
  templeadd: any;
  shlokaedit: any;
  shubasitaedit: any;
  visheshamedit: any;
  quizedit: any;
  approvaluser: any;
  date: any;
  dailydigestpreview: any;
  dailydigestshloka: any;
  dailydigestshubasita: any;
  dailydigestvishesham: any;
  dailydigestquiz: any;
  dailydigestuser: any;
  dailydigesttemple: any;
  previewquiz: any;
  count: any;
  dailydigestshlokapublish: any;
  dailydigestshubasitapublish: any;
  dailydigestvisheshampublish: any;
  dailydigestquizpublish: any;
  dailydigesttemplepublish: any;
  dailydigestuserpublish: any;
  dailydigestschedule: any;
  month: any;
  year: any;
  currentvishesham: any;
  createtvishesham: any;
  editcustomnotification: any;
  editpanchangam: any;
  permissions: string[] = [];
  isGlobalAdmin: any;
  showNotifyDropdown = false;
  showApartmentDropdown = false;
  showVendorsDropdown = false;
  showMarketingDropdown = false;
  showSettingsDropdown = false;
  showEmergencyDropdown = false;

  // Set when the user closes a dropdown that was open because of the active
  // route (XUrl()) — without this, `showXDropdown || XUrl()` in the template
  // keeps it open forever while on one of its pages, so clicking the icon to
  // close it did nothing.
  apartmentDropdownForceClosed = false;
  vendorsDropdownForceClosed = false;
  marketingDropdownForceClosed = false;
  settingsDropdownForceClosed = false;
  emergencyDropdownForceClosed = false;
  admin_id: any;
  openingSupportPanel = false;

  private firebaseListener: any; 

  constructor(
    public router: Router,
    private auth: AuthService,
    private route: ActivatedRoute,
    private db: AngularFireDatabase,
    private ngZone: NgZone,
    private orderRefresh: OrderRefreshService,
    private user: UserService,
  ) {}

  // A fresh one-time code is requested on every click; codes expire in 60s and must never be stored.
  openSupportPanel(): void {
    if (this.openingSupportPanel) return;
    this.openingSupportPanel = true;
    // Opened inside the click handler so pop-up blockers allow it; it is pointed at the SSO link once we have one.
    const tab = window.open('', '_blank');
    if (tab) {
      tab.document.title = 'Opening Support Panel…';
      tab.document.body.innerHTML = '<p style="font-family:sans-serif;padding:24px;color:#555">Opening Support Panel…</p>';
    }

    const fail = (message: string) => {
      this.openingSupportPanel = false;
      tab?.close();
      Swal.fire({ icon: 'error', title: 'Could not open the Support Panel', text: message });
    };

    this.user.openSupportPanel().subscribe({
      next: (res: any) => {
        const url = res?.data?.redirectUrl || res?.data?.redirect_url;
        if (!url || !/^https:\/\//.test(url)) {
          fail(res?.status?.message || 'The server did not return a sign-in link. Please try again.');
          return;
        }
        this.openingSupportPanel = false;
        if (tab) {
          tab.opener = null;
          tab.location.replace(url);
        } else {
          window.location.href = url;
        }
      },
      // The error interceptor rethrows the response body, not the HttpErrorResponse.
      error: (err: any) => fail(err?.status?.message || err?.message || 'Please try again in a moment.'),
    });
  }

  ngOnInit() {
    this.loadUserAccess();

    this.role_id = localStorage.getItem(`${environment.appName}` + 'role_id');
    this.firebase();
    this.user_name = localStorage.getItem(`${environment.appName}` + 'user_name');
    this.role_type = localStorage.getItem(`${environment.appName}` + 'role_type');
    this.facility_id = localStorage.getItem(`${environment.appName}` + 'facility_id');
    this.facility_name = localStorage.getItem(`${environment.appName}` + 'facility_name');
    $('#facility').val(this.facility_id);
  }

  ngOnDestroy() {
    // ✅ Detach Firebase listener to prevent memory leaks
    if (this.firebaseListener) {
      this.db.database.ref('data').off('value', this.firebaseListener);
    }
  }

  loadUserAccess() {
    const perms = localStorage.getItem('user_permissions');
    this.permissions = perms ? JSON.parse(perms) : [];
    this.userType = localStorage.getItem('userType') || '';
    this.isGlobalAdmin = this.permissions.includes('globelPermission');
  }

  hasPermission(key: string): boolean {
    return this.isGlobalAdmin || this.permissions.includes(key);
  }

  change(facility: any) {
    localStorage.setItem(`${environment.appName}` + 'facility_id', facility._id);
    localStorage.setItem(`${environment.appName}` + 'facility_name', facility.fecility_name);
    location.reload();
  }

  menu() {
    $(".user_option").toggle();
  }

  // firebase() {
  //   // ✅ Store listener reference for cleanup in ngOnDestroy
  //   this.firebaseListener = this.db.database.ref('data').on('value', (snapshot) => {
  //     if (!snapshot.exists()) return; // ✅ Ignore empty/null snapshots

  //     const rawData = snapshot.val();
  //     const data: any[] = Object.values(rawData);

  //     // Consider all relevant order statuses
  //     const allOrders = data.filter((item: any) =>
  //       ["ordered", "accepted", "picked_up", "delivered", "cancelled", "rejected"].includes(item.orderStatus)
  //     );

  //     // Extract their IDs
  //     const currentOrderIds = allOrders.map((o: any) => o.deliveryId);

  //     // Get previously seen orders from localStorage
  //     const previousOrderIds = JSON.parse(localStorage.getItem('previousOrderIds') || '[]');

  //     // Check for new orders not seen before
  //     const newOrders = currentOrderIds.filter((id: string) => !previousOrderIds.includes(id));

  //     if (newOrders.length > 0) {
  //       // this.playCustomSound(); // 🔇 Sound disabled for admin panel

  //       // Save current order IDs before reload
  //       localStorage.setItem('previousOrderIds', JSON.stringify(currentOrderIds));

  //       if (this.OrderUrl()) {
  //       setTimeout(() => {
  //         window.location.reload();
  //       }, 1000);
  //     }
  //     } else {
  //       // ✅ Always keep localStorage in sync even if no new orders
  //       localStorage.setItem('previousOrderIds', JSON.stringify(currentOrderIds));
  //     }
  //   });
  // }

  firebase() {
  // ✅ Firebase callbacks run outside Angular's zone; re-enter it so change
  // detection and the OrderRefreshService subscribers pick up correctly.
  this.firebaseListener = this.db.database.ref('data').on('value', (snapshot) => {
    this.ngZone.run(() => {
    if (!snapshot.exists()) return;
    const currentEnv = environment.env;
    const rawData = snapshot.val();
    const data: any[] = Object.values(rawData);

    const envMatched = data.filter((item: any) => !item.env || item.env === currentEnv);
      if (!envMatched.length) return;

    const allOrders = data.filter((item: any) =>
      ["ordered", "accepted", "picked_up", "delivered", "cancelled", "rejected"].includes(item.orderStatus)
    );

    // ✅ Track both ID + status so status changes are detected
    const currentOrderKeys = allOrders.map((o: any) => `${o.deliveryId}_${o.orderStatus}`);
    const previousOrderKeys = JSON.parse(localStorage.getItem('previousOrderKeys') || '[]');

    const hasChanges = currentOrderKeys.some((key: string) => !previousOrderKeys.includes(key));

    //  Always keep localStorage in sync
    localStorage.setItem('previousOrderKeys', JSON.stringify(currentOrderKeys));

    if (hasChanges && !this.wasDeliveryActive) {
      this.wasDeliveryActive = true;

      // this.playCustomSound(); // 🔇 Sound disabled for admin panel

      this.clearDatabase().then(() => {
        this.wasDeliveryActive = false;

        if (this.OrderUrl()) {
          //  No more window.location.reload() — just tell whichever
          // order list/detail component is currently mounted to re-fetch.
          this.orderRefresh.triggerRefresh();
        }
      });
    }
    });
  });
}

  // playCustomSound() {
  //   const AudioContext = window.AudioContext || (window as any).webkitAudioContext;
  //   const audioContext = new AudioContext();

  //   if (audioContext.state === 'suspended') {
  //     audioContext.resume().then(() => {
  //       console.log("🎵 Audio context resumed");
  //     });
  //   }

  //   const soundUrl = "/assets/images/swiggy_new_order.mp3";

  //   fetch(soundUrl)
  //     .then(res => res.arrayBuffer())
  //     .then(buffer => audioContext.decodeAudioData(buffer))
  //     .then(decoded => {
  //       const source = audioContext.createBufferSource();
  //       source.buffer = decoded;
  //       source.connect(audioContext.destination);
  //       source.start();
  //     })
  //     .catch(err => console.error("🔇 Sound error:", err));
  // }

clearDatabase(): Promise<void> {
  return this.db.database
    .ref()
    .remove()
    .then(() => console.log("Database cleared successfully."))
    .catch((error) => console.error("Error clearing database:", error));
}

  logout() {
    Swal.fire({
      title: 'Are You Sure You Want To Logout?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'OK'
    }).then((result) => {
      if (result.isConfirmed) {
        this.auth.logout();
        this.router.navigate(['/login']);
      } else if (result.isDenied) {
        Swal.fire('Changes are not saved', '', 'info');
      }
    });
  }

  // ── URL helpers ────────────────────────────────────────────────

  ApartmentUrl() {
    return this.HotelApartmentUrl() || this.ResidentialApartmentUrl() || this.OwnerUrl() || this.AdminLogsUrl();
  }

  AdminLogsUrl() {
    return this.router.url.includes("/admin-logs");
  }

  OwnerUrl() {
    return this.router.url.includes("/owner");
  }

  HotelApartmentUrl() {
    return this.router.url.includes("/apartment") &&
           !this.router.url.includes("residential-apartment");
  }

  ResidentialApartmentUrl() {
    // Matches the list ("/apartment/residential-apartment"), add/edit
    // ("/apartment/add-residential-apartment" — a flat sibling route, not
    // nested under residential-apartment/), and view
    // ("/apartment/residential-apartment-details") routes. The old check
    // only matched "/apartment/residential-apartment" literally, so the
    // add/edit route fell through to HotelApartmentUrl() instead and lit up
    // "Hotel Apartments" while editing a residential one.
    return this.router.url.includes("residential-apartment");
  }

  LaundryUrl() {
    return this.router.url.includes("laundry") && !this.router.url.includes("laundry-report");
  }

  RestuarantUrl() {
    return (this.router.url.includes("/restaurant") ||
            this.router.url.includes("/add-restaurant") ||
            this.router.url.includes("/restaurant-details")) &&
           !this.router.url.includes("restaurant-report");
  }

  GroceryUrl() {
    return (this.router.url.includes("/grocery") ||
            this.router.url.includes("/add-grocery") ||
            this.router.url.includes("/grocery-details"));
  }

  clubUrl() {
    return this.router.url.includes("/club") ||
           this.router.url.includes("/add-club") ||
           this.router.url.includes("/club-details");
  }

  spaUrl() {
    return this.router.url.includes("/spa") ||
           this.router.url.includes("/add-spa") ||
           this.router.url.includes("/spa-details");
  }

  carRentalUrl() {
    return this.router.url.includes("/car-rental");
  }

  adventureUrl() {
    return this.router.url.includes("/adventure");
  }

  settingUrl() {
    return this.router.url.includes("/setting") ||
           this.router.url.includes("/add-setting");
  }

  auditLogsUrl() {
    return this.router.url.includes("/audit-logs");
  }

  SettingsUrl() {
    return this.settingUrl() || this.auditLogsUrl() || this.taxUrl() ||
           this.router.url.includes('/support-panel') || this.router.url.includes('/translations');
  }

  taxUrl() {
    return this.router.url.includes("/tax") ||
           this.router.url.includes("/add-tax");
  }

  UploadBannerUrl() {
    return this.router.url.includes("/upload-banner") ||
           this.router.url.includes("/sub-imgage1") ||
           this.router.url.includes("/sub-imgage2");
  }

  staffUrl() {
    return this.router.url.includes("/staff") ||
           this.router.url.includes("/add-staff");
  }

  ReportUrl() {
    return this.router.url.includes("/laundry-report") ||
           this.router.url.includes("/room-service-report") ||
           this.router.url.includes("/restaurant-report") ||
           this.router.url.includes("/residential-report") ||
           this.router.url.includes("/club-report");
  }

  WalletUrl() {
    return this.router.url.includes("/wallet");
  }

  userAlertsUrl() {
    return this.router.url.includes("/user-alerts");
  }

  vendorSettlementUrl() {
    return this.router.url.includes("/vendor-settlement");
  }

  FAQUrl() {
    return this.router.url.includes("/feedback") ||
           this.router.url.includes("/FAQ-category");
  }

  OrderUrl() {
    return ["/all-orders", "/order-detail", "/room-order-details",
            "/food-order-details", "/additional-order-details",
            "/residential-order-details", "/club-order-details",
            "/car-rental-order-details", "/grocery-order-details"]
      .some(path => this.router.url.includes(path));
  }

  emgNotification() {
    return ["/emergency-notification", "/saved-alert", "/active-alert",
            "/alert-response", "/alert-report", "/alert-history", "/floor-mapping"]
      .some(path => this.router.url.includes(path));
  }

  VendorsUrl() {
    return this.LaundryUrl() || this.RestuarantUrl() || this.GroceryUrl() || this.clubUrl() || this.spaUrl() || this.carRentalUrl() || this.adventureUrl();
  }

  MarketingUrl() {
    return this.UploadBannerUrl() ||
           this.router.url.includes("/notification") ||
           this.router.url.includes("/admin-notification") ||
           this.router.url.includes("/ratings") ||
           this.router.url.includes("/coupon") ||
           this.FAQUrl();
  }

  openApartmentDropdown() { this.showApartmentDropdown = true; }
  closeApartmentDropdown() { this.showApartmentDropdown = false; }
  openVendorsDropdown() { this.showVendorsDropdown = true; }
  closeVendorsDropdown() { this.showVendorsDropdown = false; }
  openMarketingDropdown() { this.showMarketingDropdown = true; }
  closeMarketingDropdown() { this.showMarketingDropdown = false; }
  openNotifyDropdown() { this.showNotifyDropdown = true; }
  closeNotifyDropdown() { this.showNotifyDropdown = false; }
  openSettingsDropdown() { this.showSettingsDropdown = true; }
  closeSettingsDropdown() { this.showSettingsDropdown = false; }
  openEmergencyDropdown() { this.showEmergencyDropdown = true; }
  closeEmergencyDropdown() { this.showEmergencyDropdown = false; }

  // ── Click-to-toggle sidebar dropdowns ─────────────────────────
  // Opened/closed on click rather than hover. The template calls
  // isXDropdownOpen() for both *ngIf and the arrow rotation, so toggling
  // actually closes a dropdown even while its active route (XUrl()) would
  // otherwise force it open.
  isApartmentDropdownOpen() { return !this.apartmentDropdownForceClosed && (this.showApartmentDropdown || this.ApartmentUrl()); }
  isVendorsDropdownOpen() { return !this.vendorsDropdownForceClosed && (this.showVendorsDropdown || this.VendorsUrl()); }
  isMarketingDropdownOpen() { return !this.marketingDropdownForceClosed && (this.showMarketingDropdown || this.MarketingUrl()); }
  isSettingsDropdownOpen() { return !this.settingsDropdownForceClosed && (this.showSettingsDropdown || this.SettingsUrl()); }
  isEmergencyDropdownOpen() { return !this.emergencyDropdownForceClosed && (this.showEmergencyDropdown || this.emgNotification()); }

  toggleApartmentDropdown() {
    this.apartmentDropdownForceClosed = this.isApartmentDropdownOpen();
    this.showApartmentDropdown = !this.apartmentDropdownForceClosed;
  }
  toggleVendorsDropdown() {
    this.vendorsDropdownForceClosed = this.isVendorsDropdownOpen();
    this.showVendorsDropdown = !this.vendorsDropdownForceClosed;
  }
  toggleMarketingDropdown() {
    this.marketingDropdownForceClosed = this.isMarketingDropdownOpen();
    this.showMarketingDropdown = !this.marketingDropdownForceClosed;
  }
  toggleSettingsDropdown() {
    this.settingsDropdownForceClosed = this.isSettingsDropdownOpen();
    this.showSettingsDropdown = !this.settingsDropdownForceClosed;
  }
  toggleEmergencyDropdown() {
    this.emergencyDropdownForceClosed = this.isEmergencyDropdownOpen();
    this.showEmergencyDropdown = !this.emergencyDropdownForceClosed;
  }
}